import React from 'react'

export const Performance = ({ data }: { data: any }) => {
  return (
    <div className="mt-6 max-w-[440px] w-screen -ml-5">
      <img className="w-full" src={data.image} width="440" height="290" alt={data.title} />
      <h3 className="text-center px-5 mt-10 text-buttonGradient text-[20px] leading-[1.4] tracking-[-0.2px] mb-3 font-bold">
        {data.title}
      </h3>
      <img
        className="w-full max-w-[207px] mx-auto"
        src={data.icon}
        width="207"
        height="62"
        alt={data.title}
      />
    </div>
  )
}
